module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAgMAAADyVVYGAAAACVBMVEUAakTBJy39uROFpPmTAAAAKElEQVRIx2NYhQOsGJUZlRmVoUBmFIyCUUALEIoDhIzKjMqMypAvAwBF7jWSS5At0wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Lithuania.png
// module id = 589
// module chunks = 0